var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_c('TruncateHelper',{attrs:{"title":_vm.title,"maxWidth":_vm.maxWidth}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("action")],2),_c('v-card-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }